import React from "react";
import { PHOTOS } from "@/assets/images";

// Bento grid: 9 photos. Captions live in translations (t.gallery.items).
const GALLERY = [
  {
    url: PHOTOS.pintxoChampi,
    key: 0,
    span: "lg:col-span-7 lg:row-span-2",
    height: "h-[420px] lg:h-[640px]",
  },
  { url: PHOTOS.pintxoCroqueta, key: 1, span: "lg:col-span-5", height: "h-[310px]" },
  { url: PHOTOS.ensalada, key: 2, span: "lg:col-span-5", height: "h-[310px]" },
  { url: PHOTOS.tacos, key: 3, span: "lg:col-span-4", height: "h-[380px]" },
  { url: PHOTOS.arroz, key: 4, span: "lg:col-span-4", height: "h-[380px]" },
  { url: PHOTOS.gildas, key: 5, span: "lg:col-span-4", height: "h-[380px]" },
  { url: PHOTOS.barTap, key: 6, span: "lg:col-span-4", height: "h-[380px]" },
  { url: PHOTOS.terraceCorner, key: 7, span: "lg:col-span-4", height: "h-[380px]" },
  { url: PHOTOS.signage, key: 8, span: "lg:col-span-4", height: "h-[380px]" },
];

export default function Gallery({ t }) {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#F5F2EB] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="mb-14 flex items-end justify-between">
          <div>
            <p
              data-testid="gallery-eyebrow"
              className="mb-6 font-body text-xs uppercase tracking-[0.4em] text-[#5C3A21]"
            >
              — {t.gallery.eyebrow}
            </p>
            <h2
              data-testid="gallery-title"
              className="font-serif-display text-5xl leading-[1.05] text-[#1A1A1A] sm:text-6xl"
            >
              {t.gallery.title}
            </h2>
          </div>
          <span className="hidden font-serif-display text-2xl italic text-[#5C3A21] sm:block">
            01 — 09
          </span>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:gap-6">
          {GALLERY.map((img) => {
            const caption = t.gallery.items[img.key] || "";
            return (
              <figure
                key={img.key}
                data-testid={`gallery-item-${img.key}`}
                className={`group relative overflow-hidden ${img.span} ${img.height}`}
              >
                <img
                  src={img.url}
                  alt={caption}
                  className="h-full w-full object-cover object-center transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="pointer-events-none absolute bottom-5 left-6 right-6 font-body text-[11px] uppercase tracking-[0.3em] text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  {caption}
                </figcaption>
              </figure>
            );
          })}
        </div>

        {/* Visit the local — terraza panorámica */}
        <div className="mt-20 sm:mt-24">
          <div
            className="relative h-[420px] w-full overflow-hidden sm:h-[560px]"
            data-testid="gallery-visit-banner"
          >
            <img
              src={PHOTOS.terraceFront}
              alt={t.gallery.visitTitle}
              className="absolute inset-0 h-full w-full object-cover"
              style={{ objectPosition: "center 45%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/10" />
            <div className="relative z-10 flex h-full max-w-xl flex-col justify-end p-8 sm:p-14">
              <p
                data-testid="gallery-visit-eyebrow"
                className="mb-4 font-body text-xs uppercase tracking-[0.4em] text-[#EAE4D9]/80"
              >
                — Bergara
              </p>
              <h3
                data-testid="gallery-visit-title"
                className="font-serif-display text-4xl leading-[1.05] text-[#F5F2EB] sm:text-5xl"
              >
                {t.gallery.visitTitle}
              </h3>
              <p className="mt-4 font-body text-base text-[#EAE4D9]/90 sm:text-lg">
                {t.gallery.visitSubtitle}
              </p>
              <a
                href="#contact"
                className="mt-8 inline-flex w-fit items-center gap-3 border border-[#F5F2EB]/60 px-5 py-3 text-[#F5F2EB] transition-all hover:bg-[#F5F2EB] hover:text-[#1A1A1A]"
                data-testid="gallery-visit-cta"
              >
                <span className="font-body text-xs uppercase tracking-[0.3em]">
                  Cómo llegar
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
